class mother{
    constructor(){
        this.fileUrl = "";
        this.init()
    }
    init = () =>{

        // const intervalId = setInterval(() => {
        //     // Find the element with the class '.upcart-checkout-button'
        //     const checkoutButton = document.querySelector('.upcart-checkout-button');
            
        //     // Check if the button exists
        //     if (checkoutButton) {
        //         const newDiv = document.createElement('div');

        //         // Transfer the classes, innerHTML, and any other attributes to the new <div>
        //         newDiv.className = checkoutButton.className;  // Copy the class from <a> to <div>
        //         newDiv.innerHTML = checkoutButton.innerHTML;  // Copy the content from <a> to <div>
                
        //         // Optionally, if you want to preserve the href value, you can store it as a data attribute
        //         newDiv.setAttribute('data-href', checkoutButton.getAttribute('href'));
                
        //         // Replace the <a> tag with the new <div>
        //         checkoutButton.parentNode.replaceChild(newDiv, checkoutButton);
                
        //         // Add any custom event listeners or styles to the new div if needed
        //         newDiv.style.cursor = 'pointer';  
        //         // Clear the interval after the action is performed
        //         clearInterval(intervalId);
        //         console.log('href attribute removed from the checkout button');
        //     }
        // }, 100); // 1 second interval

        document.addEventListener('click',(e)=>{
            if(e.target.classList.contains('custom-checkout-btn')){
                e.preventDefault();
                fetch('/cart?view=check')
                .then((data)=> data.text())
                .then((data)=>{
                    
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data; // Set the HTML content
    
                    // Find the element with class 'photo-upload'
                    const photoUploadElement = tempDiv.querySelector('.photo-upload');
    
                    // Get the 'data-upload' attribute value
                    let uploadData = photoUploadElement ? photoUploadElement.dataset.upload : null;
                    uploadData = uploadData == "true" ? true : false;
                     
                    if(uploadData){
                                            // Add the 'active' class to your popup element
                        let popup = document.querySelector('#mother-photo-upload-popup');
                        if (popup) {
                            popup.classList.add('active');
                        }
                    }else{
                        window.location.href = "/checkout"
                    }
                    
                }).catch((e)=>{
                    window.location.href = "/checkout"
                })
            }
        })
        var popup = document.querySelector('#mother-photo-upload-popup');
        popup.addEventListener('click',()=>{
            popup.classList.remove('active')
        })
        var popupContent = document.querySelector('.mother-photo-upload-content');
        popupContent.addEventListener('click',(e)=>{
            e.stopPropagation()
        })
        var uploadButton = document.getElementById('upload-continue-btn');
        var fileInput = document.getElementById('file-upload');
        var errorMessage = document.querySelector('.mother-photo-upload-error');
        // const uploadcareWidget = uploadcare.Widget(fileInput);
        const uploadcareWidget = uploadcare.Widget(fileInput, {
            publicKey: "c1cdee96d2ff1051b354",  // Replace with your Uploadcare public key
            imagesOnly: true,  // Restrict to image files
            multiple: false,  // Allow only one file
            tabs: "file url",  // Allow file URL input
            previewStep: true  // Allow users to preview the file before uploading
        });
        uploadcareWidget.onUploadComplete((file)=> {
            this.fileUrl = file.cdnUrl;
        });

        // When the "Upload and Continue" button is clicked
        uploadButton.addEventListener('click', ()=> {
            // Check if no file is selected
            if (!this.fileUrl) {
                errorMessage.classList.remove('hidden'); // Show error message
            } else {
                errorMessage.classList.add('hidden'); // Hide error message
                
                    // Once the file is uploaded, get the file URL
                    const fileUrl = this.fileUrl;
            
                    // Append the file URL to FormData
                    var formData = new FormData();
                    formData.append("attributes[Mother photo]", fileUrl);

                    fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        body: formData
                    })
                    .then(response => response.json())
                    .then(data => {
                        window.location.href = "/checkout"
                    })
                    .catch(error => {
                        console.error("Error:", error);
                        window.location.href = "/checkout"
                    });
                
                // Optionally submit the form here
                // document.querySelector('form').submit(); // Uncomment if you want to submit the form
            }
        });
    
        // When the file input changes (i.e., a file is selected)
        fileInput.addEventListener('change', function() {
            if (this.files.length > 0) {
                errorMessage.classList.add('hidden'); // Hide the error message when a file is selected
            }
        });
    }
}
    new mother();
    